import ResetPasswordSuccess from "./resetPasswordSuccess.container";

export default ResetPasswordSuccess;